<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Edit Shipping Address
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="flex-row">
        <div class="ac-input-container">
          <div class="ac-input-header">
            First Name
          </div>
          <SACInput
            field="firstName"
            placeholder="Enter First Name"
            :value="firstName"
            :error="errorObj.firstNameErr"
            :change="onChange"
          />
        </div>
        <div class="ac-input-container">
          <div class="ac-input-header">
            Last Name
          </div>
          <SACInput
            field="lastName"
            placeholder="Enter Last Name"
            :value="lastName"
            :error="errorObj.lastNameErr"
            :change="onChange"
          />
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Street Address
        </div>
        <SACInput
          field="address1"
          placeholder="Enter Street Address"
          :value="address1"
          :error="errorObj.address1Err"
          :change="onChange"
        />
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Suite #, Bldg #, Etc
        </div>
        <SACInput
          field="address2"
          placeholder="Enter Suite #, Bldg #, Etc"
          :value="address2"
          :change="onChange"
        />
      </div>
      <div class="flex-row">
        <div class="ac-input-container">
          <div class="ac-input-header">
            City
          </div>
          <SACInput
            field="city"
            placeholder="Enter City"
            :value="city"
            :error="errorObj.cityErr"
            :change="onChange"
          />
        </div>
        <div class="ac-input-container">
          <div class="ac-input-header">
            State
          </div>
          <SACDropdown
            :options="statesOptions"
            :value="state"
            optionLabel="label"
            optionValue="value"
            placeholder="Select State"
            field="state"
            :error="errorObj.stateErr"
            :change="onChange"
          />
        </div>
        <div class="ac-input-container">
          <div class="ac-input-header">
            Zip
          </div>
          <SACInput
            field="zip"
            placeholder="Enter Zip"
            :value="zip"
            :error="errorObj.zipErr"
            :change="onChange"
          />
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Country
        </div>
        <SACInput
          field="country"
          placeholder="Enter Country"
          :value="country"
          :change="onChange"
          :error="errorObj.countryErr"
        />
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="handleUpdate"
      >
        Update
      </button>
    </div>
    <ProcessOverlay :show="processing" />
  </div>
</template>
<script>
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'UpdateShippingAddress',
  components: {
    SACInput,
    SACDropdown,
    ProcessOverlay,
  },
  mixins: [partnerReviewMixin],
  data() {
    return {
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      processing: false,
      errorObj: {},
    };
  },
  mounted() {
    const {
      orderLines,
    } = this.order;
    if (orderLines.length > 0) {
      const {
        shippingAddress: {
          firstName,
          lastName,
          address1,
          address2,
          city,
          state,
          zip,
          country,
        },
      } = orderLines[0];
      this.firstName = firstName;
      this.lastName = lastName;
      this.address1 = address1;
      this.address2 = address2;
      this.city = city;
      this.state = state;
      this.zip = zip;
      this.country = country;
    }
  },
  methods: {
    onChange(field, value) {
      this[field] = value;
    },
    async handleUpdate() {
      const {
        orderLines,
      } = this.order;
      const {
        firstName,
        lastName,
        address1,
        address2,
        city,
        state,
        zip,
        country,
      } = this;
      const errorObj = {};
      if (!firstName.trim()) {
        errorObj.firstNameErr = 'First name is required.';
      }
      if (!lastName.trim()) {
        errorObj.lastNameErr = 'Last name is required.';
      }
      if (!address1.trim()) {
        errorObj.address1Err = 'Street address is required.';
      }
      if (!city.trim()) {
        errorObj.cityErr = 'City is required.';
      }
      if (!state.trim()) {
        errorObj.stateErr = 'State is required.';
      }
      if (!zip.trim()) {
        errorObj.zipErr = 'Zip is required.';
      }
      if (!country.trim()) {
        errorObj.countryErr = 'Country is required.';
      }
      this.errorObj = errorObj;
      if (Object.keys(errorObj).length === 0) {
        const { shippingAddress } = orderLines[0];
        this.processing = true;
        await this.$store.dispatch('updatePartnerReviewAddress', {
          ...shippingAddress,
          firstName,
          lastName,
          address1,
          address2,
          city,
          state,
          zip,
          country,
        });
        this.processing = false;
        this.toggleActionModal(false);
      }
    },
  },
};
</script>

<style lang="scss">

.body-confirm-shipping {
  margin: 25px
}

.new-adddress-button {
  width: 75%;
  margin: 10px;
}
</style>
